export default __webpack_public_path__ + "a7a239bb7d0de81e7bc6ca1813a11328.png";